import { z } from "zod";
/** Whole-clinic day totals, independent of the Today board's row limit. */
export const TodayBoardMetricsSchema = z
    .object({
    inClinic: z.number().int().nonnegative(),
    medianWait: z.number().nonnegative(),
    longestWait: z.number().int().nonnegative(),
    completedCount: z.number().int().nonnegative(),
})
    .strict();
//# sourceMappingURL=today-board.js.map